module.exports = __webpack_public_path__ + "img/42_31.b8aae08c.png";